import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../providers/api";

const initialState = {
  user: {
    token: null,
    screens: [],
    forms: []
  },
  mainUser: {
    token: null,
    screens: [],
    forms: []
  },
  delegations: [],
  isLoading: false,
  delegationLoading: false
};

export const login = createAsyncThunk("login", async (body) => {
  const response = await api.auth.login(body);

  return response?.Data;
});

export const getActiveDelegations = createAsyncThunk(
  "get-active-delegations",
  async () => {
    const response = await api.delegation.getActive();

    return response?.Data;
  }
);

export const activateDelegation = createAsyncThunk(
  "activate-delegation",
  async (id) => {
    const response = await api.delegation.activate(id);

    return response?.Data;
  }
);

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    logout: () => {
      return initialState;
    },
    deactivateDelegation: (state) => {
      state.user = state.mainUser;
    }
  },
  extraReducers: {
    [login.fulfilled]: (state, action) => {
      const {
        Token: token,
        UserData: user,
        Screens: screens,
        Forms: forms
      } = action.payload;
      const loggedUser = {
        ...user,
        screens,
        forms,
        token
      };
      const newState = {
        user: loggedUser,
        mainUser: loggedUser,
        isLoading: false
      };
      return newState;
    },
    [login.pending]: (state) => {
      state.isLoading = true;
    },
    [login.rejected]: (state) => {
      state.isLoading = false;
      // addToast.error("error", {
      //   toastId: "error",
      // });
    },
    [getActiveDelegations.fulfilled]: (state, action) => {
      state.delegations = action.payload;
    },
    [getActiveDelegations.pending]: (state) => {
      // state.isLoading = true;
    },
    [getActiveDelegations.rejected]: (state) => {
      // state.isLoading = false;
    },
    [activateDelegation.fulfilled]: (state, action) => {
      const {
        Token: token,
        UserData: user,
        Screens: screens,
        Forms: forms
      } = action.payload;
      const loggedUser = {
        ...user,
        screens,
        forms,
        token
      };
      state.user = loggedUser;
    },
    [activateDelegation.pending]: (state) => {
      // state.isLoading = true;
    },
    [activateDelegation.rejected]: (state) => {
      // state.isLoading = false;
    }
  }
});

export const { logout, deactivateDelegation } = userSlice.actions;

export default userSlice.reducer;
